import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { combineLatest, Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { Interest } from '../interfaces/interest';
import { EnvironmentService } from './environment.service';
/**
 * The Service to load the Interests 
 */
@Injectable({
  providedIn: 'root'
})
export class InterestService {
  /**
   * constructor
   * @param http 
   * @param environment 
   */
  constructor(
    private http: HttpClient,
    private environment: EnvironmentService) {

  }

  /**
   * Get all Interests
   * @returns 
   */
  getAllInterests(): Observable<any> {
    const bodyAcitve = {
      "filterByState": "ACTIVE"
    }
    const bodyDelted = {
      "filterByState": "DELETED"
    }
    return combineLatest([
      this.environment.apiV1$.pipe(
        switchMap(url => this.http.post(`${url}/interest/search`, bodyAcitve),
        )
      ),
      this.environment.apiV1$.pipe(
        switchMap(url => this.http.post(`${url}/interest/search`, bodyDelted)
        )
      )
    ]).pipe(
      map(([active, deleted]: any) => {
        let t = [];
        active.forEach(element => {
          element["state"] = "ACTIVE"
          t.push(element)
        });

        deleted.forEach(element => {
          element["state"] = "DELETED"
          t.push(element)
        });
        return t
      }))
  }
  /**
   * Create a new Interests
   * @param interest 
   * @returns 
   */
  createInterest(interest: Interest) {
    return this.environment.apiV1$.pipe(
      switchMap(url => this.http.post(`${url}/interest`, interest)
      )
    )
  }
  /**
   * Edit an Interest
   * @param interest 
   * @returns 
   */
  editInterest(interest: Interest) {
    return this.environment.apiV1$.pipe(
      switchMap(url => this.http.put(`${url}/interest/${interest.publicId}`, interest)
      )
    )
  }
  /**
   * Get an Interest via the ID
   * @param interestID 
   * @returns 
   */
  getInterest(interestID) {
    return this.environment.apiV1$.pipe(
      switchMap(url => this.http.get(`${url}/interest/${interestID}`)
      )
    )
  }
  /**
   * Search for Interests via the Filter
   * @param State 
   * @returns 
   */
  searchForInterests(State): Observable<any> {
    const body = {
      "filterByState": State
    }
    return this.environment.apiV1$.pipe(
      switchMap(url => this.http.post(`${url}/interest/search`, body)
      )
    )
  }
  /**
   * Delete the Interest
   * @param interest 
   * @returns 
   */
  deleteInterest(interest: Interest) {
    return this.environment.apiV1$.pipe(
      switchMap(url => this.http.delete(`${url}/interest/${interest.publicId}`, {})
      )
    )
  }
}
